export const filterInitValues = (valuesList, emptyHidden, isAssetLook) => {
  if (!isAssetLook) return valuesList;
  return emptyHidden ? valuesList.filter(({ value }) => !!value) : valuesList;
};
